import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserService } from './services/user.service';
import { AppInitializerService } from './services/app-initializer.service';
import { ArrayValidatorService } from './services/array-validator.service';
import { RoutingService } from './services/routing.service';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { SharedModule } from '../common/shared/shared.module';
import { AppConfigModule } from './app-config/app-config.module';

@NgModule({
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        SharedModule,
        AppConfigModule
    ],
    providers: [
        RoutingService,
        UserService,
        HttpInterceptorService,
        AppInitializerService,
        ArrayValidatorService,
    ],
})
export class CoreModule {
}
